/* global location, localStorage */
import path from 'path'
import config from '../config'
import slug from 'slugify'

export default {
  siteUrl (...paths) {
    const [siteId] = location.pathname.substr(1).split('/')
    paths.unshift(siteId)
    paths.unshift('/')
    return path.join(...paths)
  },

  sectionUrl (...paths) {
    const [, section] = location.pathname.substr(1).split('/')
    paths.unshift(section)
    return this.siteUrl(...paths)
  },

  contentUrl (id = '') {
    const [,, typeSlug] = location.pathname.substr(1).split('/')
    return this.sectionUrl(typeSlug, id || '')
  },

  isChecked (value) {
    if (value === '1' || value === 1) return true
    if (value === '0' || value === 0) return false
    return !!value
  },

  navigate (to) {
    window.history.pushState({}, '', to)
  },

  redirect (to) {
    window.history.replaceState({}, '', to)
  },

  navigateBack () {
    window.history.back()
  },

  uploadUrl () {
    return `${config.api_uri}/content/upload?site=${this.getSite()}`
  },

  fileUrl (file = {}) {
    const token = this.getToken()
    // return `${config.api_uri}/content/upload/${name}?token=${token}&site_id=${this.getSite()}`

    return file.url
      ? file.url
      : `https://assets.fridgecms.com/${this.getSite()}/${file.name}?token=${token}`;
  },

  getToken () {
    return localStorage.getItem('accessToken')
  },

  getRefreshToken () {
    return localStorage.getItem('refreshToken')
  },

  getSite () {
    return localStorage.getItem('currentSite')
  },

  sectionKey (location) {
    const [, section] = location.split('/').slice(1)
    switch (section) {
      case 'content': return 'types'
      case 'users': return 'roles'
    }
  },

  move (arr, fromIndex, toIndex) {
    const element = arr.splice(fromIndex, 1)[0]
    arr.splice(toIndex, 0, element)
    return arr
  },

  slugify (str) {
    return slug(str, {replacement: '_', lower: true})
  }
}



// WEBPACK FOOTER //
// ./app/lib/utils.js